export default "# \u6807\u9898\n\n- \u5217\u8868\n- \u5217\u8868\n\n```\nalert('Hello')\n```\n\n[D2Admin in github](https://github.com/d2-projects/d2-admin)";